(function () {
    'use strict';

    angular
        .module('app')
        .controller('copyToClipboard', copyToClipboard);

    copyToClipboard.$inject = ['$location', '$scope', '$mdDialog', 'loginService', 'urlToCopy'];

    function copyToClipboard($location, $scope, $mdDialog, loginService, urlToCopy) {
        var vm = this;

        vm.copyToClipboardHeading = loginService.resourceStrings["COPY_URL"];
        vm.instructions = loginService.resourceStrings["COPY_URL_IPAD_INSTRUCTIONS"];
        vm.okLabel = loginService.resourceStrings["CLOSE"]; // "OK"  
        vm.urlToCopy = urlToCopy;

        activate();

        function activate() {
        }

        $scope.okButtonClicked = function () {
            // Call the parent - $mddialog's onOK()
            $mdDialog.hide();
        }

    }

})();
